// Mock data for MARKETRY

export const industries = [
  { id: 1, name: 'Retail & E-commerce', slug: 'retail' },
  { id: 2, name: 'Food & Beverage', slug: 'food' },
  { id: 3, name: 'Technology & SaaS', slug: 'tech' },
  { id: 4, name: 'Health & Wellness', slug: 'health' },
  { id: 5, name: 'Education & Training', slug: 'education' },
  { id: 6, name: 'Financial Services', slug: 'finance' },
  { id: 7, name: 'Travel & Hospitality', slug: 'travel' },
  { id: 8, name: 'Fashion & Beauty', slug: 'fashion' }
];

export const reports = [
  {
    id: 1,
    title: 'Understanding Gen Z Shopping Behavior in Australian Retail',
    industry: 'Retail & E-commerce',
    industrySlug: 'retail',
    date: '2025-01-15',
    excerpt: 'Deep dive into how Gen Z consumers navigate retail touchpoints in Australia, from social media discovery to post-purchase engagement.',
    keyInsights: [
      'Social media drives 67% of product discovery',
      'Sustainability messaging increases conversion by 34%',
      'Mobile-first checkout reduces cart abandonment'
    ],
    readTime: '8 min read'
  },
  {
    id: 2,
    title: 'Plant-Based Market Entry: Australian Consumer Touchpoints',
    industry: 'Food & Beverage',
    industrySlug: 'food',
    date: '2025-01-29',
    excerpt: 'Analysis of successful plant-based brand launches in Australia and the critical touchpoints that drive market penetration.',
    keyInsights: [
      'In-store sampling converts 45% of trial customers',
      'Health claims resonate more than environmental benefits',
      'Partnership with cafes accelerates brand awareness'
    ],
    readTime: '10 min read'
  },
  {
    id: 3,
    title: 'SaaS Customer Onboarding: The Australian Enterprise Perspective',
    industry: 'Technology & SaaS',
    industrySlug: 'tech',
    date: '2025-02-12',
    excerpt: 'How Australian enterprises evaluate and adopt SaaS solutions, with focus on the decision-making touchpoints.',
    keyInsights: [
      'Free trials with Australian customer success support increase adoption by 56%',
      'Compliance and data sovereignty are top concerns',
      'Peer recommendations influence 72% of enterprise decisions'
    ],
    readTime: '12 min read'
  },
  {
    id: 4,
    title: 'Mental Health Apps: Building Trust in the Australian Market',
    industry: 'Health & Wellness',
    industrySlug: 'health',
    date: '2024-12-18',
    excerpt: 'Exploring the unique touchpoints needed to establish credibility and drive adoption for mental health applications in Australia.',
    keyInsights: [
      'Clinical validation messaging increases trust by 89%',
      'Integration with Medicare and private health insurance is crucial',
      'Anonymous user testimonials drive initial sign-ups'
    ],
    readTime: '9 min read'
  },
  {
    id: 5,
    title: 'EdTech for International Students: Navigating the Australian Landscape',
    industry: 'Education & Training',
    industrySlug: 'education',
    date: '2024-12-04',
    excerpt: 'Understanding how international students discover and engage with educational technology platforms in Australian universities.',
    keyInsights: [
      'University partnerships drive 78% of initial adoption',
      'Peer-to-peer recommendations are the strongest touchpoint',
      'Localized content for specific visa categories increases engagement'
    ],
    readTime: '11 min read'
  },
  {
    id: 6,
    title: 'FinTech Trust Signals: What Australian Consumers Need to See',
    industry: 'Financial Services',
    industrySlug: 'finance',
    date: '2024-11-20',
    excerpt: 'Critical touchpoints for building trust and driving adoption in the highly regulated Australian financial services market.',
    keyInsights: [
      'ASIC licensing prominently displayed increases sign-ups by 43%',
      'Transparent fee structures reduce early churn',
      'Australian-based customer support is a key differentiator'
    ],
    readTime: '10 min read'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Chen',
    role: 'Marketing Student, University of Melbourne',
    content: 'Marketry reports gave our IMC project the Australian market insights we needed. The touchpoint analysis was exactly what we were missing.',
    avatar: 'SC'
  },
  {
    id: 2,
    name: 'James Peterson',
    role: 'Growth Lead, TechStart AU',
    content: 'As a startup entering the Australian market, these bi-weekly insights have been invaluable. Fresh student perspectives combined with solid research.',
    avatar: 'JP'
  },
  {
    id: 3,
    name: 'Priya Sharma',
    role: 'Business Major, UNSW',
    content: 'The reports helped me understand real-world marketing touchpoints beyond textbook theory. Perfect for my startup project.',
    avatar: 'PS'
  }
];

export const features = [
  {
    id: 1,
    title: 'Bi-Weekly Industry Reports',
    description: 'Fresh insights every two weeks covering a different industry in the Australian market',
    icon: 'Calendar'
  },
  {
    id: 2,
    title: 'Student-Led Research',
    description: 'Unique perspectives from marketing students combined with rigorous market analysis',
    icon: 'Users'
  },
  {
    id: 3,
    title: 'Touchpoint Mapping',
    description: 'Detailed analysis of every customer touchpoint in the Australian market context',
    icon: 'Map'
  },
  {
    id: 4,
    title: 'Free Access',
    description: 'All reports available free during our trial period, with premium features coming soon',
    icon: 'Gift'
  }
];

export const stats = [
  { label: 'Industries Covered', value: '8+' },
  { label: 'Reports Published', value: '24' }
];